/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    actionsEnd: "actions-end",
    bulletPointIcon: "bullet-point",
    checkbox: "checkbox",
    checkboxContainer: "checkbox-container",
    checkboxLabel: "checkbox-label",
    checkmarkIcon: "checkmark",
    chevron: "chevron",
    childrenContainer: "children-container",
    iconStart: "icon-start",
    itemExpanded: "item--expanded",
    nodeAndActionsContainer: "node-actions-container",
    nodeContainer: "node-container",
};
export const SLOTS = {
    actionsEnd: "actions-end",
    children: "children",
};
export const ICONS = {
    blank: "blank",
    bulletPoint: "bullet-point",
    checkmark: "check",
    checkSquareF: "check-square-f",
    chevronRight: "chevron-right",
    minusSquareF: "minus-square-f",
    square: "square",
};
//# sourceMappingURL=resources.js.map
